module.exports = __webpack_public_path__ + "media/images/icon/ico_top_flow01-ee6d740aa1ed989565c26122fedc5d0b.svg";